import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { DonHistoryPage } from '~/components/Don';
import { EvolvePage } from '~/components/Evolve/EvolvePage';
import { EvolveFormPage } from '~/components/Evolve/Form/EvolveFormPage';
import { LevelUpFormPage } from '~/components/LevelUp/Form/LevelUpFormPage';
import { LevelUpPage } from '~/components/LevelUp/LevelUpPage';
import { MissionPage } from '~/components/Mission/MissionPage';

export const MembershipRouteSwitch = ({ match: { path }, location }: RouteComponentProps) => (
  <Switch>
    <Route path={`${path}/item/citizen/levelup`} exact component={LevelUpPage} />
    <Route path={`${path}/item/citizen/levelup/go`} exact component={LevelUpFormPage} />
    <Route path={`${path}/item/friend/levelup`} exact component={EvolvePage} />
    <Route path={`${path}/item/friend/levelup/go`} exact component={EvolveFormPage} />
    <Route path={`${path}/don/history/:id?`} component={DonHistoryPage} />
    <Route path={`${path}/mission`} component={MissionPage} />
    <Redirect
      exact
      from={`${path}/nft/citizen/levelup`}
      to={{ pathname: `${path}/item/citizen/levelup`, search: location.search }}
    />
    <Redirect
      exact
      from={`${path}/nft/citizen/levelup/go`}
      to={{ pathname: `${path}/item/citizen/levelup/go`, search: location.search }}
    />
    <Redirect
      exact
      from={`${path}/nft/friend/levelup`}
      to={{ pathname: `${path}/item/friend/levelup`, search: location.search }}
    />
    <Redirect
      exact
      from={`${path}/nft/friend/levelup/go`}
      to={{ pathname: `${path}/item/friend/levelup/go`, search: location.search }}
    />
    <Redirect to="/" />
  </Switch>
);
